import Divider from '@mui/material/Divider';
import FormGroup from '@mui/material/FormGroup';
import { styled as styledMui5 } from '@mui/material/styles';
import { StyledButtonMui5 } from 'components/atoms/StyledButton';
import { SelectControl, SelectLabel } from 'components/atoms/Select';

export const CarPreferencesLabelMui5 = styledMui5(SelectLabel)`
  &.MuiInputLabel-root {
    margin-bottom: 1px;
    transform: none !important;
  }
`;

export const CarPreferencesSelectControlMui5 = styledMui5(SelectControl, {
  skipSx: false,
})(
  ({ theme }) => `
    &.MuiFormControl-root {
      &:not(:first-of-type) {
        margin: ${theme.spacing(1, 0, 0, 0)} !important;
      }
      margin: 0 !important;
    }`,
);

export const DynamicFiltersContainer = styledMui5(FormGroup)(({ theme }) => ({
  '&.MuiFormGroup-root': {
    marginBottom: theme.spacing(3),
  },
}));

export const DynamicFiltersLabel = styledMui5(SelectLabel)(({ theme }) => ({
  '&.MuiInputLabel-root': {
    transform: 'none !important',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: theme.spacing(3),
  },
}));

export const MSRPSliderContainerMui5 = styledMui5('div')(
  ({ theme }) => `
  margin-top: ${theme.spacing(3)};
  & .MuiSlider-root {
    margin-bottom: ${theme.spacing(0)};
  }`,
);

export const EmptyFilterDivider = styledMui5('div')(
  ({ theme: { spacing } }) => ({
    margin: spacing(1),
  }),
);

export const DoubleEmptyFilterDivider = styledMui5('div')(
  ({ theme: { spacing } }) => ({
    margin: spacing(2),
  }),
);

export const FilterDividerMui5 = styledMui5(Divider)(
  ({ theme }) => `
  &.MuiDivider-root {
    margin: ${theme.spacing(3, 0)};
  }`,
);

export const AccordionTitleContainerMui5 = styledMui5('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ClearFilterButton = styledMui5(StyledButtonMui5)(
  ({ theme }) => `
  &.MuiButton-root {
    padding: ${theme.spacing(0.1)};
  }`,
);

export const UppercaseMui5 = styledMui5('span')`
  text-transform: uppercase;
`;
